export const apiPath = '/v2/user_polygraphs';
const actionType = 'USER_POLYGRAPHS';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
